export const base = {
    "recent_test": "ສອບເສັງລ່າສຸດ",
    "parts": "ລາຍການບົດຮຽນ",
    "list_result": "ລາຍການຜົນທີ່ໄດ້ຮັບ",
    "result": "ຜົນທີ່ໄດ້ຮັບ",
    "alert_submit": "ສົ່ງ",
    "mid_test": "ສອບເສັງກາງພາກ",
    "final_test": "ສອບເສັງທ້າຍພາກ",
    "survey_type": "ສຳຫຼວດ",
    "vote_type": "ໂຫວດ",
    "learn_everywhere": "ຮຽນຮູ້ທຸກເວລາ ແລະ ທຸກທີ່",
    "confirm": "ຢືນຢັນ",
    "question": "ຄຳຖາມ",
    "continue_practice": "ສືບຕໍ່ຝຶກຫັດ",
    "retest": "ສອບເສັງຄືນ",
    "practice_lesson": "ບົດຮຽນຝຶກຫັດ",
    "retake_test": "ສອບເສັງຄືນ",
    "test": "ສອບເສັງ",
    "practice": "ຝຶກຫັດ",
    "exam": "ສອບເສັງ",
    "submit": "ສົ່ງ",
    "continue": "ຕໍ່ໄປ",
    "comeback": "ກັບຄືນ",
    "yes": "ແມ່ນແລ້ວ",
    "no": "ບໍ່",
    "your_opinion": "ຄວາມຄິດເຫັນຂອງທ່ານ",
    "back_lesson": "ກັບຄືນ",
    "correct_answer": "ຄຳຕອບທີ່ຖືກຕ້ອງ",
    "user_name": "ຊື່ຂອງນັກຮຽນ",
    "phone_number": "ເບີ​ໂທລະ​ສັບ",
};
